import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import phoneImg from "../assets/phone.webp";
import seenPill from "../assets/seen-pill.webp";
import actPill from "../assets/act-pill.webp";

export default function HomePage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1 [overflow-x:clip]" data-testid="home-main">
        {/* Hero */}
        <section className="mx-auto w-full max-w-[1366px] px-5 md:px-[77px]">
          <h1
            data-testid="hero-headline"
            className="mt-[clamp(48px,6.4vw,88px)] text-center font-spartan text-[clamp(26px,3.61vw,49px)] font-bold leading-[1.15] tracking-[0.005em] text-black"
          >
            DISCOVER . EXPERIENCE . ACT
          </h1>
          <p
            data-testid="hero-description"
            className="mx-auto mt-[clamp(18px,2vw,28px)] max-w-[1180px] text-center font-glacial text-[clamp(15px,1.77vw,24px)] leading-[1.4] text-[#7C7C7C]"
          >
            Discover places, products and experiences through people you trust —
            then turn inspiration into real-world action with Vibealone
          </p>
        </section>

        {/* Phone visual with floating labels */}
        <section
          aria-label="Vibealone app preview"
          className="mt-[clamp(40px,4.5vw,61px)] pb-2"
        >
          <div
            data-testid="phone-stage"
            className="relative mx-auto w-[63vw] sm:w-[min(486px,72vw)]"
            style={{ containerType: "inline-size" }}
          >
            <img
              src={phoneImg}
              alt="Vibealone app on an iPhone, showing a Sunday Brunch post from Hornbill Cafe with an iced coffee photo"
              className="block h-auto w-full"
              data-testid="phone-image"
              draggable="false"
            />

            {/* Floating SEEN label (left) */}
            <div
              className="absolute left-[-28.41%] top-[11.71%] w-[71.15%]"
              data-testid="seen-label"
            >
              <img
                src={seenPill}
                alt=""
                aria-hidden="true"
                className="block h-auto w-full"
                draggable="false"
              />
              <span className="absolute left-[25.7%] top-[38.5%] font-spartan text-[2.58cqw] font-bold leading-none tracking-[0.06em] text-black">
                SEEN
              </span>
              <span className="absolute left-[25.7%] top-[48%] whitespace-nowrap font-spartan text-[3.32cqw] font-bold leading-none text-black">
                Sunday brunch post
              </span>
            </div>

            {/* Floating Act label (right) */}
            <div
              className="absolute left-[60.11%] top-[65.31%] w-[84.3%]"
              data-testid="act-label"
            >
              <img
                src={actPill}
                alt=""
                aria-hidden="true"
                className="block h-auto w-full"
                draggable="false"
              />
              <span className="absolute left-[22.6%] top-[38.5%] font-spartan text-[2.58cqw] font-bold leading-none tracking-[0.06em] text-white">
                Act
              </span>
              <span className="absolute left-[22.6%] top-[49.5%] whitespace-nowrap font-spartan text-[3.32cqw] font-bold leading-none text-white">
                Turn discovery into action
              </span>
            </div>
          </div>
        </section>
      </main>
      <div className="mt-[clamp(72px,13.7vw,188px)]">
        <Footer />
      </div>
    </div>
  );
}
